"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BADGE = exports.FILTERS_MOBILE_ICONS_CONTAINER = exports.FILTERS_MOBILE = exports.FILTER_TOGGLE = exports.FILTER_TOGGLE_CONTAINER = exports.RIGHT_CONTENT_CLS = exports.DROPDOWN_CLS = exports.SEARCH_CLS = exports.FILTERS_CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../../../common/styles/vars"),
    FILTERS_CONTAINER = function FILTERS_CONTAINER(a) {
  var b = a.isMobile;
  return (0, _cxs["default"])({
    alignItems: "center",
    display: "flex",
    flexDirection: b ? "column" : "row",
    justifyContent: "space-between",
    width: "100%",
    height: b ? void 0 : "110px"
  });
};

exports.FILTERS_CONTAINER = FILTERS_CONTAINER;

var SEARCH_CLS = function SEARCH_CLS(a) {
  var b = a.bothViewsAvailable,
      c = a.isMobile;
  return (0, _cxs["default"])({
    maxWidth: "400px",
    marginRight: b && !c ? "20px" : 0,
    width: c ? "100%" : void 0
  });
};

exports.SEARCH_CLS = SEARCH_CLS;
var DROPDOWN_CLS = (0, _cxs["default"])({
  minWidth: "185px"
});
exports.DROPDOWN_CLS = DROPDOWN_CLS;
var RIGHT_CONTENT_CLS = (0, _cxs["default"])({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  "> *:not(:last-child)": {
    marginRight: "20px"
  }
});
exports.RIGHT_CONTENT_CLS = RIGHT_CONTENT_CLS;
var FILTER_TOGGLE_CONTAINER = (0, _cxs["default"])({
  position: "relative"
});
exports.FILTER_TOGGLE_CONTAINER = FILTER_TOGGLE_CONTAINER;
var FILTER_TOGGLE = (0, _cxs["default"])({
  maxWidth: "70px",
  minWidth: "70px"
});
exports.FILTER_TOGGLE = FILTER_TOGGLE;
var FILTERS_MOBILE = (0, _cxs["default"])({
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  width: "100%",
  justifyContent: "space-between",
  margin: "10px 0 10px 0",
  padding: "10px 0"
});
exports.FILTERS_MOBILE = FILTERS_MOBILE;
var FILTERS_MOBILE_ICONS_CONTAINER = (0, _cxs["default"])({
  display: "flex",
  "> .icon-container:first-child": {
    marginRight: "20px"
  }
});
exports.FILTERS_MOBILE_ICONS_CONTAINER = FILTERS_MOBILE_ICONS_CONTAINER;

var BADGE = function BADGE(a) {
  return (0, _cxs["default"])({
    display: a ? "flex" : "none",
    alignItems: "center",
    justifyContent: "center",
    width: "15px",
    height: "15px",
    backgroundColor: _vars.COLOURS.cyan.aqua,
    borderRadius: "50%",
    position: "absolute",
    top: "-4px",
    right: "-4px",
    textAlign: "center"
  });
};

exports.BADGE = BADGE;